import Api from "@/utils/axios";

import newApi from "@/utils/axios-images";
export default {
  namespaced: true,
  state: {
    rentsData:[],
    companyData:[],
    paymentWays:{}
  },
  getters: {
    getRentsData(state){
      return state.rentsData
    },
    getCompanyData(state){
      return state.companyData
    },
    getPaymentWays(state){
      return state.paymentWays
    },
  },
  mutations: {
    SET_RENTS(state, rents){
      state.rentsData = rents
    },
    SET_COMPANY_DATA(state, company){
      state.companyData = company
    },
    SET_PAYMENT_WAYS_DATA(state, pay){
      state.paymentWays = pay
    },
  },
  actions: {
    // Start Handler Rents Data 
    async handlerRentsData({commit}, id) {
      return await new Promise((resolve, reject) => {
        Api.get(`get-rent/${id}`).then((response)=>{
          commit("SET_RENTS", response.data);
          resolve(response)
        }).catch((error)=>{
          reject(error)
        })
      })
    },
    async handlerRentsDataAuth({commit}, id) {
      return await new Promise((resolve, reject) => {
        Api.get(`auth-get-rent/${id}`).then((response)=>{
          commit("SET_RENTS", response.data);
          resolve(response)
        }).catch((error)=>{
          reject(error)
        })
      })
    },
     // End Handler Rents Data 
 
    // Start Handler Get Company -- Depends on the product id
    // [User NOT AUTH]
    async handlerGetCompany({commit}, id) {
      return await new Promise((resolve, reject) => {
        Api.get(`get-companies/${id}`).then((response)=>{
          commit("SET_COMPANY_DATA", response.data);
          resolve(response)
        }).catch((error)=>{
          reject(error)
        })
      })
    },
       // [User  AUTH]
    async handlerGetCompanyForAuth({commit}, id) {
      return await new Promise((resolve, reject) => {
        Api.get(`auth-get-companies/${id}`).then((response)=>{
          commit("SET_COMPANY_DATA", response.data);
       
          resolve(response)
        }).catch((error)=>{
          reject(error)
        })
      })
    },
    // End Handler Get Company -- Depends on the product id 
    // Handler Make Order
    async handlerMakeOrder({commit}, payload) {
      return await new Promise((resolve, reject) => {
        Api.post("order", payload).then((response)=>{
          resolve(response)
        }).catch((error)=>{
          reject(error)
        })
      })
    },
    // Handler Make Order -- The second part for images
    async handlerSendImagesForMakeOrder({commit}, payload) {
      return await new Promise((resolve, reject) => {
        newApi.post("save_attatchment", payload).then((response)=>{
          resolve(response)
        }).catch((error)=>{
          reject(error)
        })
      })
    },
    // Handler Payment Order
    async handlerPaymentOrder({commit}, payload) {
      return await new Promise((resolve, reject) => {
        newApi.post("order-submit", payload).then((response)=>{
    
          resolve(response)
        }).catch((error)=>{
          reject(error)
        })
      })
    },
    // Handler Payment Ways 
    async handlerPaymentWays({commit }, id) {
      return await new Promise((resolve, reject) => {
        Api.get(`company-payment/${id}/1`).then((response)=>{
          let payWays = {
            cash:null,
            postdatedCheck:null,
            currentCheck:null,
            noWays:null,
            
          }
          
          if (response.data && response.data.length > 0) {
            response.data.forEach(element => {
              element.payments.forEach(ele => {
                if (ele == 1) {
                  payWays.cash = ele
                } else if(ele == 2){
                  payWays.postdatedCheck = ele
                } else if(ele == 3){
                  payWays.currentCheck = ele
                } 
                
              });
              payWays.noWays = false
            });
            // state.paymentWays = payWays
          } else {
            payWays.noWays = true
          }
          commit("SET_PAYMENT_WAYS_DATA", payWays);
          resolve(response)
        }).catch((error)=>{
          reject(error)
        })
      })
    },
  }
};
